import {UserInfoInputModel} from "./user-info-input.model";
import {CarInfoInputModel} from "../car-info/car-info-input.model";

export class UserInfoForRegisterTmpModel {

    // ユーザ情報
    user: UserInfoInputModel = new UserInfoInputModel;

    // お車情報
    car: CarInfoInputModel = new CarInfoInputModel;

    // ポリシー同意有無
    isCheckedAgree: boolean = false;

    public copy(obj: UserInfoForRegisterTmpModel) {
        if(obj) {
            if(obj.user) this.user.copy(obj.user);
            if(obj.car) this.car.copy(obj.car);
            this.isCheckedAgree = obj.isCheckedAgree;
        }
    }
    
    /** 初期状態を設定します */
    public initialize() {
        this.user.initialize();
        this.car.initialize();
    }
}